var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    className: "q-icon",
    "aria-hidden": "true",
    role: "presentation",
    viewBox: "0 0 24 24",
    "data-v-5ea012e0": "",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "pen-outline",
    width: "100%",
    height: "100%",
    viewBox: "0 0 128 128"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.81,45.19a2.43,2.43,0,1,0,2.44,2.43A2.44,2.44,0,0,0,17.81,45.19Zm0,3.59A1.16,1.16,0,1,1,19,47.61,1.17,1.17,0,0,1,17.81,48.78Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.06,45.19a2.43,2.43,0,1,0,2.44,2.43A2.44,2.44,0,0,0,47.06,45.19Zm0,3.59a1.16,1.16,0,1,1,1.17-1.16A1.17,1.17,0,0,1,47.06,48.78Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.06,82.52A2.43,2.43,0,1,0,49.5,85,2.44,2.44,0,0,0,47.06,82.52Zm0,3.59A1.16,1.16,0,1,1,48.23,85,1.17,1.17,0,0,1,47.06,86.12Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.81,82.52A2.43,2.43,0,1,0,20.25,85,2.44,2.44,0,0,0,17.81,82.52Zm0,3.59A1.16,1.16,0,1,1,19,85,1.17,1.17,0,0,1,17.81,86.12Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,44.48V43.22h-4.63v-6a8.81,8.81,0,0,0-17.62,0v6H85.12v-6a8.81,8.81,0,0,0-17.62,0v6H55.87v-6a8.81,8.81,0,0,0-17.62,0v6H26.62v-6A8.81,8.81,0,0,0,9,37.26V99.5H26.62V89.66H38.25V99.5H55.87V89.66H67.5V99.5H85.12V89.66H96.75V99.5h17.62V89.66H119V88.4h-4.63V82.13H119V80.87h-4.63V52H119V50.75h-4.63V44.48ZM25.34,98.23H10.27v-61a7.54,7.54,0,0,1,15.07,0Zm12.9-9.84H26.62V82.13H38.25Zm0-7.53H26.62V52H38.25Zm0-30.12H26.62V44.48H38.25ZM54.6,98.23H39.52v-61a7.54,7.54,0,0,1,15.07,0ZM67.5,88.4H55.87V82.13H67.5Zm0-7.53H55.87V52H67.5Zm0-30.12H55.87V44.48H67.5ZM83.84,98.23H68.77v-61a7.54,7.54,0,0,1,15.07,0Zm12.91-9.84H85.12V82.13H96.75Zm0-7.53H85.12V52H96.75Zm0-30.12H85.12V44.48H96.75ZM113.1,98.23H98v-61a7.54,7.54,0,0,1,15.07,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.31,45.19a2.43,2.43,0,1,0,2.44,2.43A2.44,2.44,0,0,0,76.31,45.19Zm0,3.59a1.16,1.16,0,1,1,1.17-1.16A1.17,1.17,0,0,1,76.31,48.78Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.56,50a2.43,2.43,0,1,0-2.44-2.43A2.44,2.44,0,0,0,105.56,50Zm0-3.59a1.16,1.16,0,1,1-1.17,1.16A1.17,1.17,0,0,1,105.56,46.45Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.56,82.52A2.43,2.43,0,1,0,108,85,2.44,2.44,0,0,0,105.56,82.52Zm0,3.59A1.16,1.16,0,1,1,106.73,85,1.17,1.17,0,0,1,105.56,86.12Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.31,82.52A2.43,2.43,0,1,0,78.75,85,2.44,2.44,0,0,0,76.31,82.52Zm0,3.59A1.16,1.16,0,1,1,77.48,85,1.17,1.17,0,0,1,76.31,86.12Z",
    transform: "translate(0 0)"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pen-outline",
    fill: "#525957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFans);
export default __webpack_public_path__ + "static/media/fans.483ac73025cfc76d5e9ad1ebad79898c.svg";
export { ForwardRef as ReactComponent };